import {Button} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {Link} from 'react-router-dom'

export const ButtonBack = () => {
  const {t} = useTranslation()
  const isJbp = sessionStorage.getItem('jbp') === 'jbp'
  const path = isJbp ? '/master/price/jbp' : '/master/price/non-jbp'

  return (
    <Link to={path}>
      <Button variant='secondary' className='me-2'>
        {t('Back')}
      </Button>
    </Link>
  )
}
